import { emojis, shortcodeToEmoji } from '@tiptap-pro/extension-emoji';

export const resolveEmojiName = (name: string): string | null => {
  const result = shortcodeToEmoji(name, emojis);
  return result?.emoji ?? null;
};
